import helpers from './helpers';

export default (function () {
  return {
    selector: document.querySelectorAll('.js-count-up'),
    init() {
      if (this.selector.lenght === 0) return;
      this.selector.forEach((elem) => {
        this.isInViewport(elem);
      });
    },
    initCountUp(selector, start = 0, duration = 1000) {
      const target = selector;
      const targetValue = Number(target.dataset.count);
      const targetUnit = target.dataset.unit;
      let startTimestamp = null;

      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        target.innerText = Math.floor(progress * (targetValue - start) + start) + targetUnit;
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };

      window.requestAnimationFrame(step);
    },

    isInViewport(target) {
      // eslint-disable-next-line compat/compat
      const io = new IntersectionObserver(
        (entries, observer) => {
          helpers.forEach(entries, (i, entry) => {
            if (entry.isIntersecting) {
              const elem = entry.target;
              this.initCountUp(elem, 0, 1000);
            }
          });
        },
        { threshold: [0.6] },
      );

      io.observe(target);
    },
  };
})();
